import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createBlock(_component_a_table, {
    dataSource: _ctx.datasource,
    columns: _ctx.column,
    pagination: _ctx.pageData,
    onChange: _ctx.tableChangeHandle
  }, {
    bodyCell: _withCtx(({ column, record }) => [
      (column.key === 'flag')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (record.pgaFlags?.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.pgaFlags, (tag) => {
                    return (_openBlock(), _createBlock(_component_a_tag, {
                      key: tag,
                      color: _ctx.getColor(tag)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(tag), 1)
                      ]),
                      _: 2
                    }, 1032, ["color"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["dataSource", "columns", "pagination", "onChange"]))
}